<template>
  <nav class="ui left fixed vertical menu fuzzy-list">
    <Spinny :promise="settingsPromise" />
    <Placy
      v-if="!settings.length"
      :promise="settingsPromise"
      :empty-message="$t('NO_THING_YET', { thing: $tc('SETTING', 2) })"
      :error-message="$t('ERR', { action: $t('READ', { thing: $tc('SETTING', 2) }) })"
    />

    <router-link class="item" :to="{ name: 'new-setting' }">
      <i class="plus icon" />
      <strong>{{ $t('NEW', { thing: $tc('SETTING', 1) }) }}</strong>
    </router-link>

    <router-link
      v-for="setting in settingsWithGroupNames"
      :key="setting.id"
      class="item"
      :active-class="'active'"
      :to="{ name: 'setting', params: { settingId: setting.id } }"
    >
      <div class="content" :title="setting.group">
        <div class="group ellipsis" :title="setting.forGroupName">
          {{ setting.forGroupName }}
        </div>
        <div class="version" :title="setting.forVersion">
          {{ setting.forVersion }}
        </div>
      </div>
    </router-link>
  </nav>
</template>

<style lang="scss" scoped>
@charset "utf-8";
@import '../../scss/variables';

nav {
  overflow-y: scroll;
}

.group {
  font-weight: bold;
  margin-bottom: 0.5em;
}
</style>

<script>
// @flow
import _ from 'lodash'
import { Spinny, Placy } from 'ui'
import Vue from 'vue'
import { Settings, Toast, Typenames, Group } from 'services'
import { map, catchError } from 'rxjs/operators'
import { ActionTypes } from 'store'
import fuzzy from 'fuzzy'

export default {
  name: 'settings-list',
  components: { Spinny, Placy },

  data() {
    return {
      settingsPromise: null
    }
  },

  computed: {
    settings() {
      return this.$store.state.manatee_settings.items
    },
    groups() {
      return this.$store.state.group.items
    },
    settingsWithGroupNames() {
      return _.map(this.settings, s => {
        const group = _.find(this.groups, g => g.id === s.forGroup)
        return {
          forGroupName: group ? group.name : s.forGroup,
          ...s
        }
      })
    }
  },

  created() {
    this.settingsPromise = Promise.all([Group.readAllGroups(), Settings.readAllSettings()])
  }
}
</script>
